import { faCompass } from '@fortawesome/free-regular-svg-icons/faCompass';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { styled as styledMui5 } from '@mui/material/styles';
import { Theme as ThemeMui5 } from '@mui/material/styles/createTheme';
import TypographyMui5 from '@mui/material/Typography';
import { SxProps } from '@mui/system';
import { Timer } from 'components/atoms/Timer';
import {
  BoldBody2IconTimerTextStylerBlue,
  BoldBody2IconTimerTextStyler as OfferCardTimerTextStyler,
} from 'components/atoms/TimerCommonStylers';
import Like from 'components/molecules/Like';
import { format } from 'date-fns';
import { FC } from 'react';
import { AuctionFromSearch } from 'shared/types/api/getAuctions';
import { AuctionTypes } from 'shared/types/models';
import { lightThemeMui5 } from 'theme';
import { OfferCardMedia } from './OfferCardMedia';

type Props = {
  sx?: SxProps<ThemeMui5>;
  auction: AuctionFromSearch;
  isAuctionEnded: boolean;
  isFutureAuction?: boolean;
};

const OfferCardHeaderContainer = styledMui5('div')(
  ({ theme }) => `
  padding-left: ${theme.spacing(2)};
  padding-right: ${theme.spacing(2)};
  padding-top: ${theme.spacing(2)};
  display: flex;
  justify-content: space-between;
  height: 58.5px;
  flex-direction: row-reverse;`,
);

export const OfferCardHeader: FC<Props> = ({
  sx = {},
  auction,
  isAuctionEnded,
  isFutureAuction,
}) => {
  return (
    <OfferCardHeaderContainer sx={sx}>
      <div style={{ minWidth: '42.5px', minHeight: '42.5px' }}>
        <Like auction={auction} ssrLiked={false} />
      </div>
      {isFutureAuction && (
        <div style={{ padding: '10px 10px 10px 0px' }}>
          <Timer startTime={auction.start_time} textPrefix=''>
            {BoldBody2IconTimerTextStylerBlue}
          </Timer>
        </div>
      )}
      {auction.type === AuctionTypes.Dutch &&
        !isAuctionEnded &&
        !isFutureAuction && (
          <TypographyMui5
            variant='body2'
            style={{ padding: '10px 10px 10px 0px' }}
          >
            <FontAwesomeIcon
              size='lg'
              icon={faCompass}
              color={lightThemeMui5.palette.secondary.main}
            />{' '}
            Dynamic Price Auction
          </TypographyMui5>
        )}
      {(auction.type === AuctionTypes.Classic || isAuctionEnded) &&
        !isFutureAuction && (
          <div style={{ padding: '10px 10px 10px 0px' }}>
            <Timer
              textCompleted={
                isAuctionEnded
                  ? format(new Date(auction.end_time), 'MMM do, yyyy')
                  : undefined
              }
              endTime={auction.end_time}
            >
              {OfferCardTimerTextStyler}
            </Timer>
          </div>
        )}
    </OfferCardHeaderContainer>
  );
};

OfferCardMedia.displayName = 'OfferCardMedia';
